import { Link, useNavigate } from 'react-router-dom'
import Header from '../../components/Header'
import Page from '../../components/Page'
import { useCreateProduzione } from '../../hooks/produzioni'
import ProduzioneForm from '../../components/ProduzioneForm'

export default function ProduzioneCreate() {
  const createProduzione = useCreateProduzione()
  const navigate = useNavigate()

  return (
    <Page>
      <Header margins>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to="/produzioni">Produzioni</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Aggiungi
            </li>
          </ol>
        </nav>
      </Header>
      <div className="py-3 overflow-y-auto flex-1">
        <ProduzioneForm
          save={async (prod) => {
            const newProd = await createProduzione.mutateAsync(prod)
            navigate(`/produzioni/${newProd.id}`)
          }}
        />
      </div>
    </Page>
  )
}
